import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Adam Locke --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Send third-party events to Chronosphere";
const frontMatter = {
  "title": "Send third-party events to Chronosphere"
};
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    h1: "h1",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Send third-party events to Chronosphere"}</_components.h1>{"\n"}<_components.p>{"You can send third-party events to Chronosphere, which display as change events\nwithin Changes Explorer, and as change events on dashboards, traces, and services,\nand query results for monitors. This integration lets you visualize more of your\nevents within Chronosphere and have a single location for identifying anomalies\nacross your environment."}</_components.p>{"\n"}<_components.p>{"Chronosphere lets you receive change events from these products:"}</_components.p>{"\n"}<_components.ul>{"\n"}<_components.li><_components.a href="/ingest/third-party/aws-eventbridge">{"Amazon EventBridge"}</_components.a></_components.li>{"\n"}<_components.li><_components.a href="/ingest/third-party/buildkite">{"Buildkite"}</_components.a></_components.li>{"\n"}<_components.li><_components.a href="/ingest/third-party/circleci">{"CircleCI"}</_components.a></_components.li>{"\n"}<_components.li><_components.a href="/ingest/third-party/github">{"GitHub"}</_components.a></_components.li>{"\n"}<_components.li><_components.a href="/ingest/third-party/gitlab">{"GitLab"}</_components.a></_components.li>{"\n"}<_components.li><_components.a href="/ingest/third-party/google-cloud">{"Google Cloud Personalized Service Health"}</_components.a></_components.li>{"\n"}<_components.li><_components.a href="/ingest/third-party/harness">{"Harness"}</_components.a></_components.li>{"\n"}<_components.li><_components.a href="/ingest/third-party/launchdarkly">{"LaunchDarkly"}</_components.a></_components.li>{"\n"}</_components.ul></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/ingest/third-party',
  {"filePath":"pages/ingest/third-party.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)